'use strict';

class CheckIn {
    wrap;
    ui;
    allHours;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.ui = {
                reasons: $(this.wrap).find('.js-check-in-reasons'),
                day: $(this.wrap).find('.js-check-in-day'),
                times: $(this.wrap).find('.js-check-in-times'),
                date: $(this.wrap).find('.js-check-in-date'),
                time: $(this.wrap).find('.js-check-in-time'),
                selectedReason: $(this.wrap).find('.js-check-in-selected-reason'),
                selectedTime: $(this.wrap).find('.js-check-in-selected-time'),
                picker: $(this.wrap).find('duet-date-picker')
            };
        }

        this.allHours = [];

        this.generateHours();
        this.bindUIActions();
        // this.datePicker();
        this.changeDay();
        this.changeTimes();

        setTimeout(() => {
            $('#DateOfBirth').prop('autocomplete', 'off')
                .on('keydown paste focus mousedown', e => this.disableInput(e));
        }, 1000);
    }

    bindUIActions() {
        this.ui.reasons.on('change', this.changeReasons);
        this.ui.day.on('change', this.changeDay);
        this.ui.times.on('change', this.changeTimes);
    }

    disableInput(e) {
        if (e.keyCode !== '9') {
            e.preventDefault();
        }
    }

    generateHours() {
        // const day = this.ui.day.val();

        let optionsList = this.ui.times.find('option');

        optionsList.each((index, el) => {
            const $option = $(el);

            this.allHours.push(
                {
                    value: $option.val(),
                    text: $option.text(),
                    date: $option.data('group')
                }
            );
        });

        console.log(this.allHours);
    }

    changeReasons() {
        const currUrlBase = '?reason=';

        window.location = currUrlBase + this.ui.reasons.val() + '#check-in';
    }

    changeDay() {
        const day = this.ui.day.val();

                    let optionsList = this.ui.times.find('option');

                    optionsList.remove();

        this.allHours.forEach(el => {
            if (el.date === day) {
                this.ui.times.append(`<option value='${el.value}'>${el.text}</option>`);
            }
        });

        if (this.ui.times.length > 0) {
            this.ui.times.removeAttr('disabled');
        }

        // const first = this.ui.times.find(`option[data-group="${day}"]`).first();

        // this.ui.times.val(first.val()).trigger('change');
    }

    changeTimes() {
        const selectedTime = this.ui.times.val(),
            d = new Date(selectedTime);

        this.ui.selectedTime.val(selectedTime);

        // Show the date only if there are open spots
        if ($('.js-check-in-times option').length > 0) {
            this.ui.date.html(`${d.getMonth() + 1}-${d.getDate()}-${d.getFullYear()}`);
        } else {
            this.ui.date.html('');
        }

        this.ui.time.html($('.js-check-in-times option:selected').text());
    }

    datePicker() {
        var picker = document.querySelector('duet-date-picker'),
            DATE_FORMAT = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

        picker.dateAdapter = {
            parse: function parse() {
                var value = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0],
                    createDate = arguments[1],
                    matches = value.match(DATE_FORMAT);

                if (matches) {
                    return createDate(matches[3], matches[2], matches[1]);
                }
            },
            format: function format(date) {
                return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
            }
        };

        picker.localization = {
            buttonLabel: 'Choose date',
            placeholder: 'mm/dd/yyyy',
            selectedDateMessage: 'Selected date is',
            prevMonthLabel: 'Previous month',
            nextMonthLabel: 'Next month',
            monthSelectLabel: 'Month',
            yearSelectLabel: 'Year',
            closeLabel: 'Close window',
            keyboardInstruction: 'You can use arrow keys to navigate dates',
            calendarHeading: 'Choose a date',
            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            locale: 'en-US'
        };
    }
}

export default CheckIn;


